<micro-select-combo #sel
                    placeholder="Department"
                    routerBase="departments"
                    [(id)]="departmentId"
                    (idChange)="change($event)"
                    [options]="options"
                    [required]="required"
                    [jump]="jump"
                    [disabled]="disabled"
                    [requires]="requires()"
>
</micro-select-combo>
